<header id="app-header" class="h-26 z-10 sticky top-0"></header>

<mat-sidenav-container class="flex-grow !flex flex-col !overflow-visible">
  <mat-sidenav
               #appSidenav
               fixedInViewport
               id="app-sidenav"
               [mode]="sideBarState.mode$()"
               [opened]="sideBarState.opened$()"
               position="end"
               class="!top-26 max-w-full">
    <public-sidebar></public-sidebar>
  </mat-sidenav>

  <mat-sidenav-content class="flex-grow !flex flex-col !overflow-visible isolate">
    <div class="app-watermark"></div>
    <router-outlet class="hidden [&_+_*]:flex-1"></router-outlet>

    <mat-divider></mat-divider>
    <footer app-footer class="mt-auto !flex-none"></footer>
    @if (cookieBanner.show$()) {
    <cookie-policy-banner (animate.leave)="cookieBanner.animateOnLeave($event)"></cookie-policy-banner>
    }
  </mat-sidenav-content>
</mat-sidenav-container>